import axios from './axios';

export const getRecallsByVin = (vin) => axios.get(`cars/campaign/recalls/` + vin);



// WEBPACK FOOTER //
// ./src/requesters/recalls.js